import AboutInfo from "../../components/about-info";
import VisionMissionValue from "../../components/vision-mission-value";
import Goals from "../../components/goals";
import "./about.scss";

const About = () => {
  return (
    <>
    <AboutInfo/>
    <VisionMissionValue/>
    <Goals/>
    </>
  );
};

export default About;
